<template>
  <div id="tool-filter">
    <div class="form-group">
      <label>Tìm kiếm theo tên</label>
      <div class="input-group mb-4">
        <input v-model="search_name_field" class="form-control" placeholder="Search" type="text" @change="input_field_search('name', search_name_field)">
        <div class="input-group-prepend">
          <button class="btn btn-success input-group-text" @click="input_field_search('name', search_name_field)"><i class="fa fa-search"></i></button>
        </div>        
      </div>
    </div>
    <div class="form-group">
      <label>Tìm kiếm theo nơi sinh sống</label>
      <div class="input-group mb-4">
        <input v-model='search_address_field' class="form-control" placeholder="Nơi sinh sống" type="text" @change="input_field_search('address', search_address_field)">
        <div class="input-group-prepend">
          <button class="btn btn-success input-group-text" @click="input_field_search('address', search_address_field)"><i class="fa fa-map-marker"></i> </button>
        </div>        
      </div>
    </div>
    <div class="form-group">
      <label>Tìm kiếm theo trường</label>
      <div class="input-group mb-4">
        <input v-model='search_university_field' class="form-control" placeholder="Tìm kiếm theo tên trường" type="text" @change="input_field_search('university', search_university_field)">
        <div class="input-group-prepend">
          <button class="btn btn-success input-group-text" @click="input_field_search('university', search_university_field)"><i class="fa fa-graduation-cap"></i></button>
        </div>        
      </div>
    </div> 
    <div class="form-group">
      <label>Dịch vụ</label>
      <div class="input-group mb-4">
        <multiselect
          v-model="search_services_field"
          :options="list_services" 
          placeholder="Chọn dịch vụ"
          :multiple="true" 
          label="name"
          track-by="name"
          :allow-empty="false"
          :show-labels="false"
          @input="input_service_search('services', search_services_field)"
        ></multiselect>
      </div>
    </div>    
</div>
</template>
<script>
  import Multiselect from 'vue-multiselect';
  import {mapState, mapMutations} from "vuex";  
  export default{
    components:{
      Multiselect
    },
    data: function(){
      return{
        search_name_field: '',
        search_address_field: '',
        search_university_field: '',
        search_services_field: []
      }
    },
    // created: {

    // },
    computed:{
      ...mapState('vuex_network_counselors',[
        'status_search',
        ]),
      ...mapState('services', [
        'list_services'
      ])
    },
    watch: {
      search_services_field(){
        // console.log(this.search_services_field)
      }
    },
    methods:{
      ...mapMutations('vuex_network_counselors',[
        'set_status'
      ]),
      input_field_search: function(state, keyword){
        if (keyword  != ''){
          this.set_status(state) 
        }else
        {
          this.set_status('default')
        }
        this.$store.dispatch('vuex_network_counselors/load_list_counselors', {keyword: keyword, page: this.current_page})
      },
      input_service_search: function(state, services){
        this.set_status(state)
        this.$store.dispatch('vuex_network_counselors/load_list_counselors', {keyword: services, page:this.current_page})
      }
      
    }
  };  
</script>
<style lang="scss" scoped>
  @import "./tool_filter"
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/views/components/NetworkCounselor/ToolFilter.vue